// src/pages/Operator/Operator.jsx (MODIFIED)

import React, { useState, useEffect } from "react"; // <-- Tambah useState, useEffect
import { Link } from "react-router-dom";
import { NavBarLogin } from "../../components"; // <-- Sesuaikan path ini jika perlu
import { db } from "../../config/firebase"; // <-- Tambahkan IMPORT FIREBASE
import { ref, onValue } from "firebase/database"; // <-- Tambahkan IMPORT FIREBASE DB FUNCTIONS

// ... (KODE STYLES SAMA SEPERTI SEBELUMNYA) ...

// Node di Realtime Database untuk menyimpan URL PDF dan metadata
const DB_NODE = "pdf_links";

const Operator = () => {
  const [wartaMeta, setWartaMeta] = useState(null);
  const [tataMeta, setTataMeta] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(true);

  // 1. Hook untuk mengambil Metadata dari Realtime DB
  useEffect(() => {
    const linksRef = ref(db, DB_NODE);

    // Listener untuk mengambil data
    const unsubscribe = onValue(
      linksRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          // Asumsikan data disimpan dengan key 'warta' dan 'tata'
          setWartaMeta(data.warta_meta || null);
          setTataMeta(data.tata_meta || null);
        }
        setLoadingStatus(false);
      },
      (error) => {
        console.error("Gagal mengambil status PDF:", error);
        setLoadingStatus(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // 2. Fungsi Pembantu untuk Format Tanggal dan Teks
  const formatMeta = (meta) => {
    if (!meta) return "Belum pernah diunggah atau data tidak tersedia.";

    const date = new Date(meta.timestamp);
    const formattedDate = date.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const uploadedBy = meta.uploadedBy || "Operator Tidak Diketahui";

    return `Diperbarui terakhir pada ${formattedDate} oleh ${uploadedBy}`;
  };

  // CSS yang disesuaikan dengan palet warna baru
  const embeddedStyles = `
        .churchOperatorPage {
            min-height: 100vh;
            padding: 20px;
            background-color: #f7f7f7; 
            color: #4A4A4A; 
            font-family: 'Inter', sans-serif;
        }

        .operatorHeader {
            text-align: center;
            margin-bottom: 40px;
            padding-top: 20px;
        }

        .operatorHeader h1 {
            color: #6F42C1; /* Ungu Tua */
            font-size: 2.8em;
            margin-bottom: 0.1em;
            font-weight: 700;
        }

        .operatorHeader .lead {
            font-size: 1.2em;
            color: #808080; 
        }

        .operatorActions {
            max-width: 1200px;
            margin: 0 auto 40px auto;
        }

        .operatorActions h2 {
            border-bottom: 3px solid #6F42C1; /* Ungu Tua */
            padding-bottom: 15px;
            margin-bottom: 25px;
            color: #343A40; /* Abu Tua */
            font-size: 1.8em;
        }

        .actionGrid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 25px;
        }

        .actionCard {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background-color: #FFFFFF; 
            padding: 25px;
            border-radius: 12px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
            text-decoration: none;
            color: #343A40; /* Abu Tua */
            transition: all 0.3s ease;
            border-left: 6px solid #6F42C1; /* Ungu Tua */
        }

        .actionCard:hover {
            transform: translateY(-8px);
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
            background-color: #F8F4FF; /* Latar belakang card saat hover (ungu sangat muda) */
        }

        .actionCard h3 {
            margin-top: 0;
            margin-bottom: 5px;
            color: #6F42C1; /* Ungu Tua */
            font-size: 1.4em;
        }

        .actionCard p {
            margin-bottom: 0;
            font-size: 0.95em;
            color: #808080; 
            line-height: 1.4;
        }

        .operatorContent {
            max-width: 1200px;
            margin: 40px auto;
        }

        .operatorContent h2 {
            border-bottom: 1px dashed #ADB5BD; /* Abu-abu Sedang */
            padding-bottom: 10px;
            margin-bottom: 20px;
            color: #343A40; /* Abu Tua */
            font-size: 1.8em;
        }

        .statusBox {
            background-color: #F3F1FB; 
            border: 1px solid #DCD3F5; 
            padding: 20px;
            border-radius: 12px;
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .statusBox .muted {
            color: #6F42C1; /* Ungu Tua untuk teks status */
            font-weight: 500;
            margin-bottom: 15px;
            display: block;
        }
        
        /* Gaya baru untuk detail status */
        .statusDetail {
            margin-bottom: 10px;
            font-size: 1em;
            color: #343A40;
        }
        
        .statusDetail strong {
            color: #6F42C1;
            font-weight: 700;
        }

        .operatorFooter {
            text-align: center;
            padding: 30px 20px 20px 20px;
            border-top: 1px solid #ADB5BD; 
            background-color: #EDEDED; 
        }

        .operatorFooter small {
            color: #808080; 
            font-size: 0.9em;
        }
    `;

  return (
    <>
      <NavBarLogin />
      <style>{embeddedStyles}</style>
      <main className="churchOperatorPage" role="main">
        <header className="operatorHeader">
          <h1>⛪️ Dashboard Operator Gereja</h1>
          <p className="lead">
            Area manajemen konten untuk operator pelayanan.
          </p>
        </header>

        <section className="operatorActions">
          <h2>Update Jadwal Ibadah & Dokumen PDF </h2>
          <div className="actionGrid">
            {/* Link Ibadah Minggu */}
            <Link to="/operator/ibadah-minggu" className="actionCard">
              <h3>Ibadah Minggu Sesi 1 & 2 </h3>
              <p>Update jadwal Ibadah Minggu</p>
            </Link>

            {/* Link Ibadah Kompelka */}
            <Link to="/operator/ibadah-kompelka" className="actionCard">
              <h3>Kompelka Aras Jemaat</h3>
              <p>Update jadwal Pelayanan dan Persekutuan</p>
            </Link>

            {/* Link Warta & Tata */}
            <Link to="/operator/update-warta-tata" className="actionCard">
              <h3>Warta Jemaat & Tata Ibadah</h3>
              <p>Upload Dokumen Warta Jemaat & Tata Ibadah Mingguan</p>
            </Link>

            {/* Update Renungan */}
            <Link to="/operator/update-renungan" className="actionCard">
              <h3>Update Renungan</h3>
              <p>Buat dan upload renungan harian untuk jemaat</p>
            </Link>
          </div>
        </section>

        <section className="operatorContent">
          <h2>Status Dokumen PDF</h2>
          <div className="statusBox">
            {loadingStatus ? (
              <p className="muted">Memuat status dokumen...</p>
            ) : (
              <>
                <p className="statusDetail">
                  <strong>Warta Jemaat:</strong> {formatMeta(wartaMeta)}
                </p>
                <p className="statusDetail">
                  <strong>Tata Ibadah:</strong> {formatMeta(tataMeta)}
                </p>
              </>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default Operator;
